var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEyeShow = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.25,
  d: "M12 5C7.636 5 3.258 7.922.514 10.94a3 3 0 0 0 0 4.12C3.258 18.078 7.636 21 12 21s8.742-2.922 11.486-5.94a3 3 0 0 0 0-4.12C20.742 7.922 16.364 5 12 5"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 13,
  r: 4.5,
  fill: "currentColor"
})));
export { SvgEyeShow as ReactComponent };